export type TennisDoublesPartner = {
  name: string;
  playerId?: string | null;
  image?: string | null;
};

/** Backend-enriched partners for a doubles side (from ATP/WTA + Goalserve profile). */
export function getTennisDoublesPartners(participant: unknown): TennisDoublesPartner[] | undefined {
  if (!participant || typeof participant !== "object") return undefined;
  const raw = (participant as { doublesPartners?: unknown }).doublesPartners;
  if (!Array.isArray(raw) || raw.length !== 2) return undefined;

  const partners = raw
    .map((row) => {
      if (!row || typeof row !== "object") return null;
      const name = String((row as { name?: string }).name || "").trim();
      if (!name) return null;
      return {
        name,
        playerId: (row as { playerId?: string | null }).playerId ?? null,
        image: (row as { image?: string | null }).image ?? null,
      };
    })
    .filter((row): row is TennisDoublesPartner => row != null);

  return partners.length === 2 ? partners : undefined;
}
